import * as React from "react";
import { useState, useEffect} from 'react';
import PageContainer from "../core/PageContainer";
import Breadcrumbs from "../core/Breadcrumbs";
import Card from "../core/Card";
import SortableTree from 'react-sortable-tree';
import FileExplorerTheme from 'react-sortable-tree-theme-file-explorer';
import { jfetch, toast } from "../../utils";
import * as Sentry from "@sentry/browser";
import Loader from '../core/Loader'
import Button from "../core/Button";


function ResourcesTree(props) {
  
const [tree, setTree] = useState(null)
const [isLoading, setIsLoading] = useState(false)
useEffect(() => {
  if(props.treeData){
    formatTree(props.treeData);
  }
}, []);

function formatTree(treeData){
  let cloneTree = [...treeData]
  cloneTree.forEach( category => {
    mergeChildren(category);
    if(category.children && category.children.length > 0){
      category.children.forEach(category => {
        mergeChildren(category);
      });
    }
  })
  setTree(cloneTree)
}

function mergeChildren(category){
  if(category.files && category.files.length > 0){
    category.files.forEach(file => {
      let fObj = {'key': `${file.id}`, 'value': `${file.id}`, 'title':file.name, type:'Resource'};
      category.children.push(fObj);
    });
  }
}


function handleChange(treeData){
  setTree(treeData)
}

function handleSave(){
  setIsLoading(true)
    jfetch
    .post(`/resource_categories/tree_update`, {tree})
    .then(() => {
      setIsLoading(false)
      toast.success('You resources were saved!');
    })
    .catch(e => {
      toast.error("Error while saving data.");
      Sentry.captureException(e);
    });
}

const canDrop = ({ node, nextParent, prevPath, nextPath}) => {
  let isResource = (node.type == 'Resource')
  let isRootFolder = (nextParent == null)
  // cannot drop a resource file in the root folder
  if( isResource && isRootFolder){
    return false
  }
  // cannot put anything under a resource file 
  if(!isRootFolder && nextParent.type == 'Resource'){
    return false
  }
  return true
}

return (
  <PageContainer>
  <Breadcrumbs crumbs={[{ label: "Resource Tree" }]} />
  <Card title={"Drag and Drop to arrange Categories & Files"}>
    <div className="row">
      <div className="col-lg-12">
        <Button onClick={() => handleSave()} className={'btn-success pull-right'} loading={isLoading}>
          Save
        </Button>
      </div>
    </div>
    <div style={{ height: 600, color:'black' }}>
      {tree && (
        <SortableTree
        treeData={tree}
        onChange={treeData => handleChange(treeData) }
        // onMoveNode={treeData => handleMove(treeData)}
        canDrop={canDrop}
        theme={FileExplorerTheme}
        rowHeight={30}
        generateNodeProps={({ node, path }) => ({
          title: (
              <a href={node.url} style={{color:'black', fontSize:'25px'}}>
                { node.type == 'ResourceCategory' ? 
                  (
                  <i className="fa fa-folder" style={{marginRight:'8px'}}></i>
                  )
                :
                  (
                    <i className="fa fa-file-text-o" style={{marginRight:'8px'}}></i>
                  )
                }
                {node.title}
              </a>
          ),
      })}        
      />
      )}
    </div>
  </Card>
</PageContainer>
);
}
export default ResourcesTree


// WEBPACK FOOTER //
// ./app/javascript/components/pages/ResourcesTree.tsx